import { render } from "./CargaMasiva.vue?vue&type=template&id=4a0639ae&scoped=true"
import script from "./CargaMasiva.vue?vue&type=script&lang=js"
export * from "./CargaMasiva.vue?vue&type=script&lang=js"

import "./CargaMasiva.vue?vue&type=style&index=0&id=4a0639ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0639ae"]])

export default __exports__